import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b9d9dab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type-parameter_name" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 1,
  class: "type-parameter_input-block"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type-parameter_divider" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type-parameter_divider" }, null, -1))

import { CrossCompactIcon, CheckIcon } from "tir-style-system/icons/outline";
import { TaskParameterModel } from "../models";
import { PropType, ref } from "vue";
import {
  TirPmInput,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'type-parameter',
  props: {
  /**Данные о настройке */
  data: { type: Object as PropType<TaskParameterModel>, default: () => new TaskParameterModel() },
  /**Скрыть удаление */
  hideRemove: { type: Boolean },
  /**Демонстрационный тег */
  preview: { type: Boolean, default: false },
},
  emits: ["remove"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Активно редактирование */
const isEditing = ref(false);
/**Новое имя параметра */
const newName = ref();
/**Активно наведение */
const isHover = ref(false);

/**Переключение флага isHover */
const setHover = (_isHover) => {
  isHover.value = isEditing.value ? false : _isHover;
};
/**Переключение редактирования */
const editingParameter = (value) => {
  if (!props.preview) isEditing.value = value;
};
/**Смена имени параметра */
const changeName = (parameter: TaskParameterModel, name: string | number) => {
  parameter.Name = String(name);
  isEditing.value = false;
};
/**Запись имени параметра */
const setName = (value) => {
  newName.value = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "type-parameter",
    onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (setHover(true))),
    onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (setHover(false)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!isEditing.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            textContent: _toDisplayString(props.data.Name),
            onDblclick: _cache[0] || (_cache[0] = ($event: any) => (editingParameter(true)))
          }, null, 40, _hoisted_2))
        : _createCommentVNode("", true),
      (isEditing.value && !__props.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(TirPmInput), {
              class: "type-parameter_input",
              color: props.data.Color,
              "is-with-hint": false,
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (editingParameter(true))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (editingParameter(false))),
              onKeyup: [
                _cache[3] || (_cache[3] = _withKeys(($event: any) => (changeName(props.data, newName.value ?? props.data.Name), editingParameter(false)), ["enter"])),
                _cache[4] || (_cache[4] = _withKeys(($event: any) => (editingParameter(false)), ["esc"]))
              ],
              modelValue: __props.data.Name,
              onInput: _cache[5] || (_cache[5] = ($event: any) => (setName($event))),
              isMicro: "",
              autoFocus: ""
            }, null, 8, ["color", "modelValue"]),
            _hoisted_4,
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small,
              onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (changeName(props.data, newName.value ?? props.data.Name)), ["stop"])),
              class: "type-parameter_icon"
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CheckIcon), { class: "type-parameter_icon" })
              ]),
              _: 1
            }, 8, ["variant", "size"]),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small,
              onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (editingParameter(false)), ["stop"])),
              class: "type-parameter_icon"
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CrossCompactIcon), { class: "type-parameter_icon" })
              ]),
              _: 1
            }, 8, ["variant", "size"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!__props.hideRemove)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "type-parameter_delete",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (emit('remove')), ["stop"]))
          }, [
            _createVNode(_unref(CrossCompactIcon))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 32))
}
}

})